import { Button, Modal } from 'react-bootstrap'
import { BsCheckLg, BsQuestionCircleFill, BsXLg } from 'react-icons/bs'

export function ModalRestorePassword({ teacher, onAccept, onReject, loading, ...props }) {
    return (
        <Modal centered {...props}>
            <Modal.Header>
                <span className='h5 mb-0'>Confirmar</span>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex align-items-center gap-3'>
                    <div>
                        <BsQuestionCircleFill className='text-primary' style={{ fontSize: '2.5rem' }} />
                    </div>
                    <div className=''>
                        <span style={{ fontSize: '1.1rem' }}>
                            ¿Esta seguro de <span className='fw-medium'>RESTABLECER</span> la contraseña del Docente{' '}
                            <span className='fw-medium'>{teacher}</span> a su Carnet de Identidad?
                        </span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outline-primary' onClick={onReject} style={{ width: '5rem' }}>
                    <BsXLg className='me-1' />No
                </Button>
                <Button onClick={onAccept} style={{ width: '5rem' }} disabled={loading}>
                    <BsCheckLg className='me-1' />Si
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
